import { getId } from '../../helpers/file';
import { getFailedFiles } from '../../helpers/uploadState';
import type { ImgCloudUserInfo } from '../../services/userInfo';

const maskEmail = (email?: string) => {
  if (!email || !email.includes('@')) return email;
  const [name, domain] = email.split('@');
  return `${name.slice(0, 1)}***@${domain}`;
};

const safeJson = async (res: Response) => {
  try {
    return await res.json();
  } catch {
    return null;
  }
};

export const collectSupportContext = async (
  extra: Record<string, unknown> = {},
  userInfo: ImgCloudUserInfo | null = null,
) => {
  const uid = getId() || undefined;
  const latestFailure = getFailedFiles().slice(-1)[0];

  const context: Record<string, unknown> = {
    source: 'img-cloud',
    uid,
    route: window.location.pathname,
    path: window.location.pathname,
    lastUploadError: latestFailure ? {
      fileName: latestFailure.fileName,
      errorMessage: latestFailure.errorMessage,
      traceId: latestFailure.traceId,
      fileSize: latestFailure.fileSize,
      fileType: latestFailure.fileType,
    } : undefined,
    ...extra,
  };

  try {
    const [storageRes] = await Promise.allSettled([
      fetch('/img/stat').then(safeJson),
    ]);

    if (userInfo) {
      context.user = {
        uid,
        loggedIn: true,
        emailMasked: maskEmail(userInfo.email || userInfo.username),
        vip: Boolean(userInfo.vip),
        vipEndTime: userInfo.vipEndTime,
        path: window.location.pathname,
      };
    } else {
      context.user = { uid, loggedIn: false, path: window.location.pathname };
    }

    if (storageRes.status === 'fulfilled' && storageRes.value) {
      context.storage = {
        totalSize: storageRes.value.totalSize,
        fileCount: storageRes.value.count || storageRes.value.fileCount,
      };
    }
  } catch {
    context.user = { uid, loggedIn: false, path: window.location.pathname };
  }

  return context;
};
